import React from 'react';
import { useTranslation } from 'react-i18next';
export const Importmodal = (props) => {

    const { t } = useTranslation();
    const { setImportfile, readExcel, importfile, SampleExcel, hideSample, extensions, sampleModalId } = props
    const allowedExtensions = extensions || (!hideSample ? ['.xls', '.xlsx'] : ['.xls', '.xlsx', '.zip']);
    return (
        <div
            className="modal fade import-modal"
            id="ImportModal"
            tabIndex={-1}
            aria-labelledby="ImportModalLabel"
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header"
                        onClick={() => setImportfile()}>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="modal-body">
                        <div className="import-modal-choose-file">
                            {t("choose file")}
                            <input
                                type="file"
                                onChange={(e) => {
                                    const selectedFile = e.target.files[0];
                                    if (!selectedFile) return;
                                    const fileExtension = selectedFile.name.split('.').pop().toLowerCase();

                                    if (!allowedExtensions.includes('.' + fileExtension)) {
                                        alert(extensions ? `Please select a ${extensions.join(', ')} file.` : !hideSample ? "Please select an Excel file." : "Please select an Excel or ZIP file.");
                                        e.target.value = '';
                                    } else {
                                        setImportfile(selectedFile);
                                    }
                                }}
                                name="files"
                                accept={allowedExtensions.join(", ")}
                            />
                        </div>
                        <div className="import-modal-file  w-100">
                            {importfile?.name}
                        </div>
                    </div>
                    <div id="clickonme" className="modal-footer">
                        <button
                            type="button"
                            onClick={() => { readExcel(); setImportfile() }}
                            data-bs-dismiss="modal"
                            className="btn modal-content-yes"
                        >
                            {t("Submit")}
                        </button>
                        {!hideSample &&
                            <button
                                onClick={() => {
                                    setImportfile();
                                    if (sampleModalId) {
                                        setTimeout(() => {
                                            const el = document.getElementById(sampleModalId);
                                            if (!el) return;
                                            const Modal = window.bootstrap?.Modal;
                                            if (Modal) {
                                                Modal.getOrCreateInstance(el).show();
                                            } else {
                                                el.classList.add("show");
                                                el.style.display = "block";
                                                document.body.classList.add("modal-open");
                                            }
                                        }, 250);
                                    } else if (typeof SampleExcel === "function") {
                                        SampleExcel();
                                    }
                                }}
                                id="download"
                                type="button"
                                data-bs-dismiss="modal"
                                className="btn modal-content-yes"
                            >
                                {t("Sample")}
                            </button>}

                    </div>
                </div>
            </div>
        </div>
    )
};
export default Importmodal;
